// extracted by mini-css-extract-plugin
export var active = "_sq-1";
export var circle = "_sq-0";
export var completed = "_sq-2";
export var connector = "_sq-4";
export var connectorCompleted = "_sq-7";
export var connectorSpacer = "_sq-5";
export var iconStrokeOverride = "_sq-8";
export var labelContainer = "_sq-6";
export var pending = "_sq-3";